<template>
  <div>
    <Card :bordered="false" shadow>
      <operator-setting @ResetList="operlt" :modal.sync="settingmodal" :stateModal="stateModal"></operator-setting>
      <modal-log ref="ModalLog"></modal-log>
      <Button
        type="primary"
        class="mb-3"
        @click="addOperator"
        v-if="getpermission.operator[1] == '1'"
      >新增</Button>
      <Row type="flex" align="middle">
        <table class="TB_COLLAPSE" width="100%">
          <thead>
            <th>序号</th>
            <th>帐号</th>
            <th>名称</th>
            <th>操作员组</th>
            <th>是否有效</th>
            <th>已登录？</th>
            <th>已被封锁？</th>
            <th>更新时间</th>
            <th v-if="getpermission.operator[2] == '1'">修改</th>
            <th v-if="getpermission.operator[2] == '1'">啟用/停用</th>
            <th v-if="getpermission.operator[2] == '1'">解锁</th>
            <th v-if="getpermission.operator[3] == '1'">日誌</th>
          </thead>
          <tbody>
            <tr v-for="(it, index) in datatb" :key="index+'index'">
              <td>{{it.id}}</td>
              <td>{{it.username}}</td>
              <td>{{it.memname}}</td>
              <td>{{it.opername}}</td>
              <td class="fontweight">
                <span v-if="it.state == 1" class="green-text">有效</span>
                <span v-if="it.state == 0" class="red-text">无效</span>
              </td>
              <td class="fontweight">
                <span v-if="it.aonline == 1" class="green-text">在线</span>
                <span v-if="it.aonline == 0" class="red-text">离线</span>
              </td>
              <td class="fontweight">
                <span v-if="it.blockade == 1" class="green-text">正常</span>
                <span v-if="it.blockade == 0" class="red-text">封锁</span>
              </td>
              <td>{{it.updetm}}</td>
              <td v-if="getpermission.operator[2] == '1'">
                <Button type="warning" @click="modifyOperator(it.id)">修改</Button>
              </td>
              <td v-if="getpermission.operator[2] == '1'">
                <Button v-if="it.state == 1" type="error" @click="opersaene(it.id,0)">停用</Button>
                <Button v-if="it.state == 0" type="success" @click="opersaene(it.id,1)">啟用</Button>
              </td>
              <td v-if="getpermission.operator[2] == '1'">
                <Button v-if="it.blockade == 1" type="error" @click="opersalkl(it.id,0)">封锁</Button>
                <Button v-if="it.blockade == 0" type="success" @click="opersalkl(it.id,1)">解锁</Button>
              </td>
              <td v-if="getpermission.operator[3] == '1'">
                <Button type="info" @click="triggerModalLog(it.id)">登入日誌</Button>
              </td>
            </tr>
          </tbody>
        </table>
      </Row>
      <divider />
    </Card>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: 'list',
  components: {
    OperatorSetting: () => import( /* webpackChunkName: "operator" */ "./components/OperatorSetting.vue"),
    ModalLog: () => import(  /* webpackChunkName: "operator" */ "./components/ModalLog.vue")
  },
  data () {
    return {
      datatb: [],
      settingmodal: false,
      stateModal: {
        state: "1",
        listid: null
      }
    };
  },
  computed: {
    ...mapGetters(['getpermission'])
  },
  created () {
    this.operlt();
  },
  methods: {
    triggerModalLog (id) {
      this.$refs.ModalLog.getOperatorLog(id)
    },
    addOperator () {
      this.settingmodal = true;
      this.stateModal.state = "1"
      this.stateModal.listid = null
    },
    modifyOperator (id) {
      this.settingmodal = true;
      this.stateModal.state = "2"
      this.stateModal.listid = id
    },
    async operlt () {
      try {
        const res = await this.$axios.operator.getOperatorlist()
        if ('status' in res && res.status === 0) return
        this.datatb = res;
      } catch (error) {
        console.error(error)
      }
    },
    opersaene (oid, actio) {
      this.$Modal.confirm({
        title: "提示信息",
        content: "确认是否要更改 ?",
        onOk: res => {
          this.$axios.operator.opersaene({ oid, actio }).then(res => {
            if (res.status == "1") {
              this.$Message.success("已更改");
              this.operlt();
            } else {
              this.operlt();
            }
          });
        }
      });
    },
    opersalkl (oid, actio) {
      this.$Modal.confirm({
        title: "提示信息",
        content: "确认是否要更改 ?",
        onOk: res => {
          this.$axios.operator.opersalkl({ oid, actio }).then(res => {
            if (res.status == "1") {
              this.$Message.success("已更改");
              this.operlt();
            } else {
              this.operlt();
            }
          });
        }
      });
    }
  }
};
</script>
